import Component from '../../components/component/component';
import {
    debounce,
    DebouncedFunction,
} from '../../components/helpers/helpers';

import './movie-details.scss';

export default class MovieDetails extends Component {
    static initSelector: string = '.movie-details';

    description: HTMLElement;
    descriptionInner: HTMLElement;
    debouncedResizeHandler: DebouncedFunction<() => void>;
    more: string;
    less: string;
    toggleButton: HTMLElement;
    isExpanded: boolean;

    constructor(target: HTMLElement) {
        super(target);

        this.description = this.element.querySelector('.movie-details__description');
        this.descriptionInner = this.description.querySelector('.movie-details__description-inner');
        this.more = this.description.getAttribute('data-more');
        this.less = this.description.getAttribute('data-less');
        this.debouncedResizeHandler = debounce(this.resizeHandler.bind(this), 50);
        this.isExpanded = false;

        this.init();
    }

    init(): void {
        if (this.description !== null) {
            this.resizeHandler();
            window.addEventListener('resize', this.debouncedResizeHandler);
        }
    }

    resizeHandler(): void {
        const descriptionHeight: number = parseInt(window.getComputedStyle(this.descriptionInner).height);
        const lineHeight: number = parseInt(window.getComputedStyle(this.descriptionInner).lineHeight);
        const toggleButton: string = '<button class="movie-details__toggle" type="button">' + this.more + '</button>';

        if (descriptionHeight > lineHeight * 4) {
            this.toggleButton = this.element.querySelector('.movie-details__toggle');

            this.close();

            if (!this.element.contains(this.toggleButton)) {
                this.description.insertAdjacentHTML('afterend', toggleButton);
                this.toggleButton = this.element.querySelector('.movie-details__toggle');

                this.toggleButton.addEventListener('click', this.toggle.bind(this));
            }
        }

        if (this.isExpanded) {
            this.open();
        } else {
            this.close();
        }
    }

    toggle(): void {
        if (this.isExpanded) {
            this.close();
            this.toggleButton.textContent = this.more;
        } else {
            this.open();
            this.toggleButton.textContent = this.less;
        }

        this.isExpanded = !this.isExpanded;
    }

    open(): void {
        this.description.style.maxHeight = window.getComputedStyle(this.descriptionInner).height;
    }

    close(): void {
        const lineHeight: number = parseInt(window.getComputedStyle(this.descriptionInner).lineHeight);

        this.description.style.maxHeight = lineHeight * 4 + 'px';
    }
}
